<div class="dialog-header">
  <h2 class="light-blue-text">{{ title }}</h2>
  @if (helpUrl) {
    <a [href]="helpUrl" target="_blank" rel="noopener noreferrer" class="help-button">
      <mat-icon>help_outline</mat-icon>
    </a>
  }
</div>
